import { Typography } from "@mui/material";
import { useAuth } from "context/authContext";
import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isLoggedIn, loading, currentUser } = useAuth();
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (!loading && !currentUser) {
  //     navigate("/login");
  //   }
  // }, [currentUser, navigate, loading]);
  // if (loading) {
  //   return null;
  // }

  if (loading) {
    return <Typography>Loading...</Typography>; // Add a proper loading spinner here if needed
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
